<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        展示棚に追加する
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" @click.stop="">
                    <div class="list-group mb-3" v-if="genres.length > 0">
                        <a href="#" class="list-group-item list-group-item-action d-flex justify-content-between"
                            :class="{
                                'disabled': v.hondana_count == $store.state.max_hondana
                            }"
                            v-for="v in genres"
                            @click.prevent="addBook(v.id)">
                            <div>
                                <i class="fas fa-plus"></i>
                                <strong>
                                    {{ v.genre_name }}
                                </strong>
                            </div>
                            <div :class="{
                                'text-danger': v.hondana_count == $store.state.max_hondana
                            }">
                                {{ v.hondana_count }}
                                /
                                {{ $store.state.max_hondana }}
                                冊
                            </div>
                        </a>
                    </div>
                    <div v-else class="mb-3">
                        「展示棚」がありません。
                        <p v-if="$store.state.user && $store.state.user.subdomain">
                            マイページ＞ジャンルから「展示棚」を作成してください。<br>
                            展示棚はジャンルの一種ですが、自分自身の作品ではなく、他の作家さんの作品を展示します。
                        </p>
                        <p v-else>
                            サブドメインを取得してください。
                        </p>
                    </div>
                    <div v-if="show_form">
                        <div class="input-group">
                            <input type="text" v-model="genre_name" class="form-control" placeholder="展示棚の名前">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" @click="appendHondana()">
                                    <i class="fas fa-plus"></i>
                                    展示棚追加
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="$store.state.user && $store.state.user.subdomain && count < $store.state.max_genre">
                        <button type="button" class="btn btn-link" @click="show_form = true">
                            <i class="fas fa-edit"></i>
                            展示棚を追加...
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: "add-hondana"
        },
        book: {
            default: null
        },
    },
    data() {
        return {
            genres: [],
            count: 0,
            show_form: false,   // 追加モード
            genre_name: "",
        }
    },
    methods: {
        load() {
            axios.get("/mypage/genres/count?is_hondana=1").then(res => {
                this.genres = res.data.genres;
                this.count  = res.data.count;
            }).catch(err => { alert.err(err) });
        },
        addBook(id) {
            axios.post("/mypage/genre/books/add", {
                genre_id: id,
                book_id: this.book.id
            }).then(res => {
                alert.msg(res.data);
                this.$emit("saved");
                $("#" + this.id).modal("hide");
            }).catch(err => {
                alert.err(err.response);
            });
        },
        appendHondana() {
            axios.post("/mypage/genre/save", {
                genre_name: this.genre_name,
                description: "",
                is_hondana: true,
            }).then(res => {
                this.load();
                this.genre_name = "";
                this.show_form = false;
            }).catch(err => { alert.err(err) });
        }
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.load();
        });
    }
}
</script>